let API_URL = null;
if (window.location.hostname.indexOf('4boxes.com.au') > -1) {
  API_URL = 'https://api.4boxes.com.au/api';
} else {
  API_URL = 'https://four-boxes.herokuapp.com/api';
}

export default API_URL;